import Maincontent from "./Pages/Maincontent";

function Device() {
  return (
    <>
      <div className="dashboardcontent">
        <Maincontent />
      </div>
    </>
  );
}

export default Device;
